import config from 'cio/config/environment';
import { OAuthProvider, Provider } from 'cio/utils/oauth';

export default class SegmentOauth extends OAuthProvider {
  name = Provider.Segment;
  baseUrl = 'https://id.segmentapis.com/oauth2/auth';
  clientId = config.oAuth.segment.apiKey;
  scope = 'destination/customer.io';
  extraParams = {};

  protected get redirectUri() {
    return `${window.location.origin}/torii/redirect.html`;
  }
}
